module.exports = __webpack_public_path__ + "../assets/img/mockup2.daf6a24d.png";